import React from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { APIContext } from '../Contexts/APIContext';
import "./PowerBi.css"
import { Typography } from '@mui/material';

interface IPowerBIReport {
    otherLinksId: string;
    isSelected: boolean
}
export default function PowerBIReport(props: IPowerBIReport) {
    const { get } = React.useContext(APIContext);
    const [pbiToken, setPbiToken] = React.useState('');
    const [tokenExpires, setTokenExpires] = React.useState('');
    const [embedURL, setEmbedURL] = React.useState<string>('');
    const [, setRefreshTimer] = React.useState<any>();

    React.useEffect(() => {
        if (pbiToken) {
            generateEmbedURL();
        }
    }, [pbiToken]);

    React.useEffect(() => {
        getPBIToken();
    }, [props.otherLinksId]);

    // The token is held in state only: as a cookie it rode on every API request, where the WAF logged it.
    const getPBIToken = async () => {
        if (tokenExpires !== "" && tokenExpires !== null) {
            setRefreshTimer(setTimeout(() => {
                onRefresh();
            }, 900000));
        }

        get('Report', `GetToken`, (data) => {
            setPbiToken(data);
            const expire = new Date();
            expire.setTime(expire.getTime() + 1 * 3600 * 1000); // 1 hour
            setTokenExpires(expire.toUTCString());
        });
    }

    const generateEmbedURL = () => {
        fetch('https://api.powerbi.com/v1.0/myorg/reports/' + props.otherLinksId, {
            method: 'GET',
            headers: {
                'cache-control': 'no-store, must-revalidate, no-cache',
                'content-type': 'application/json; odata.metadata=minimal',
                'Authorization': 'Bearer ' + pbiToken
            }
        })
            .then(response => response.json())
            .then(embedData => {
                setEmbedURL(embedData.embedUrl);
                console.log('embedurl is ' + embedData.embedUrl)
            })
            .catch(error => { console.log('Report fetch error: ' + error.message); });
    }

    const onRefresh = () => {
        getPBIToken();
    }

    return (
        (!(props.otherLinksId === "" || props.otherLinksId === null) ?
            <>
                <div id="reportContainer" style={props.isSelected ? { height: '100%', display: 'flex', flexDirection: 'column' } : { width: '0px', height: '0px', visibility: 'hidden' }}>{/*Microsoft: "display CSS attribute is not set to 'none' as this can cause unexpected behaviors"*/}
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report',
                            id: props.otherLinksId,
                            embedUrl: embedURL,
                            accessToken: pbiToken,
                            tokenType: models.TokenType.Aad,
                            settings: {
                                background: models.BackgroundType.Transparent,
                                visualSettings: {
                                    visualHeaders: [
                                        {
                                            settings: {
                                                visible: true
                                            }
                                        }
                                    ]
                                },
                                layoutType: models.LayoutType.Custom,
                                customLayout: {
                                    displayOption: models.DisplayOption.FitToPage,
                                },
                                panes: {
                                    filters: {
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: false
                                    }
                                }
                            }
                        }}

                    />
                </div>
            </>
            :
            <Typography sx={props.isSelected ? { } : { width: '0px', height: '0px', visibility: 'hidden' }} variant="h6">Other links are not available. Please contact ResQ IT.</Typography>
            )
    );
}